// extracted by mini-css-extract-plugin
export default {"container":"upload-modal_container__3eDfA","closeButton":"upload-modal_closeButton__9uJi-","inner":"upload-modal_inner__39x8m","title":"upload-modal_title__2yDSP"};